export default __webpack_public_path__ + "static/media/hy.6ea77aa7.png";